<template>
  <BaseModal
    :show="isOpen"
    size="sm"
    :title="t('app.views.cashRegister.cutSession') || 'Cut Session'"
    :show-actions="true"
    :save-text="t('app.views.cashRegister.cut') || 'Cortar'"
    @close="$emit('close')"
    @save="handleSave"
  >
    <CutOverview
      :report="report"
      :cash="cash"
      :card="card"
      :digital="digital"
      :other="other"
      :custom-payments="customPayments"
      :initial-balance="initialBalance"
    />
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseModal from '@/components/common/BaseModal.vue';
import CutOverview from './CutOverview.vue';
import type { CutReport } from '@/utils/cashRegisterHelpers';

const { t } = useI18n();

const props = defineProps<{
  isOpen: boolean;
  report: CutReport;
  cash: number;
  card: number;
  digital: number;
  other: number;
  customPayments: Record<string, number>;
  initialBalance?: number;
}>();

const emit = defineEmits<{
  close: [];
  save: [data: Record<string, number>];
}>();

// Create ref for all payment method values to emit on save
const paymentValues = ref<Record<string, number>>({
  cash: props.cash,
  card: props.card,
  digital: props.digital,
  other: props.other,
  ...props.customPayments
});

// Watch for prop changes
watch(() => props.cash, (newVal) => {
  paymentValues.value = { ...paymentValues.value, cash: newVal };
});
watch(() => props.card, (newVal) => {
  paymentValues.value = { ...paymentValues.value, card: newVal };
});
watch(() => props.digital, (newVal) => {
  paymentValues.value = { ...paymentValues.value, digital: newVal };
});
watch(() => props.other, (newVal) => {
  paymentValues.value = { ...paymentValues.value, other: newVal };
});
watch(() => props.customPayments, (newVal) => {
  paymentValues.value = { ...paymentValues.value, ...newVal };
}, { deep: true });

const handleSave = () => {
  emit('save', { ...paymentValues.value });
};
</script>
